import type { LngLatArr } from './interfaces';

const EARTHS_RADIUS_IN_KM = 6371;

/*
 * This uses the 'haversine' formula to calculate the great-circle distance between two points.
 * First all values used by the formula are converted into radians before the following formula is applied.
 *
 * a = sin²(Δφ/2) + cos φ1 ⋅ cos φ2 ⋅ sin²(Δλ/2)
 * c = 2 ⋅ atan2( √a, √(1−a) )
 * d = R ⋅ c
 * φ is latitude, λ is longitude, R is earth's radius (mean radius = 6 371km),
 * c is the angular distance in radians, and a is the square of half the chord length between the points.
 */
export const kilometersBetween = (point1: LngLatArr, point2: LngLatArr): number => {
    const lat1 = (point1[1] * Math.PI) / 180;
    const lat2 = (point2[1] * Math.PI) / 180;
    const deltaLat = ((point2[1] - point1[1]) * Math.PI) / 180;
    const deltaLng = ((point2[0] - point1[0]) * Math.PI) / 180;

    const a = Math.sin(deltaLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return EARTHS_RADIUS_IN_KM * c;
};
